var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 201,
    viewBox: "0 0 1920 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 155L80 185L94.5 188.53L110.5 191.53L127 194.03L138.5 195.53L154 197.03L172 198.53L188.5 199.53L200 200.03L346 199.03L437.5 192.53L535.5 182.53L617 165.53L697 144.53L770 126.03L808.5 117.53L845 111.53L917.5 103.03L994 99.0303H1063.5L1133 102.53L1202 107.03L1271.5 112.53L1399 119.53H1441L1463 118.53L1524 114.53L1591 109.53L1655.5 103.03L1679 99.5303L1706.5 95.0303L1731.5 90.0303L1751.5 85.5303L1766.5 81.5303L1779.5 77.5303L1800 70.5303L1811 66.0303L1822 61.0303L1841.5 50.5303L1881 25.5303L1920 0V201H0V155Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactSvg);
export default __webpack_public_path__ + "static/media/contactSvg.e57f831c34bee34123532773ef242121.svg";
export { ForwardRef as ReactComponent };